import { Component, inject, Input, OnDestroy } from '@angular/core';
import { ErrorWarning } from '../../models/error-warning.model';
import { ErrorWarningService } from '../../services/error-warning.service';
import { TranslateModule } from '@ngx-translate/core';
import { PopupService } from '@cms_root/app/core/services/popup.service';
import { RouterModule } from '@angular/router';
import { ErrorWarningModalOptions, ErrorWarningModalSource } from '../../models/error-warning-modal-data.model';
import { ResourceWarningsComponent } from '../resource-warnings/resource-warnings.component';
import { DefaultWarningsComponent } from '../default-warnings/default-warnings.component';
import { ButtonModule } from '@cms_root/app/shared/button/button.module';

@Component({
  selector: 'app-error-warning-modal',
  imports: [RouterModule, TranslateModule, ButtonModule, DefaultWarningsComponent, ResourceWarningsComponent],
  templateUrl: './error-warning-modal.component.html',
  styleUrls: ['./error-warning-modal.component.scss']
})
export class ErrorWarningModalComponent implements OnDestroy {
  private readonly errorWarningService = inject(ErrorWarningService);
  private readonly popupService = inject(PopupService);

  private isActionClicked = false;
  isLoading: boolean;

  @Input() uuid: number;
  @Input() data: ErrorWarning;
  @Input() source: ErrorWarningModalSource;
  @Input() options: ErrorWarningModalOptions;

  ngOnDestroy(): void {
    if (this.isActionClicked) {
      return;
    }

    this.errorWarningService.cancel(this.uuid);
  }

  getTitle(warningsTranslation: string, errorsTranslation: string): string {
    const titleSegments: string[] = [];

    if (this.data?.warnings?.length > 0) {
      titleSegments.push(warningsTranslation);
    }

    if (this.data?.errors?.length > 0) {
      titleSegments.push(errorsTranslation);
    }

    return !titleSegments?.length ? warningsTranslation : titleSegments.join(' / ');
  }

  onCancel(): void {
    this.isActionClicked = true;
    this.errorWarningService.cancel(this.uuid);

    if (!this.options?.autoCloseDisabled) {
      this.popupService.popupHide();
    }
  }

  onContinue(): void {
    this.isActionClicked = true;
    this.errorWarningService.continue(this.uuid);

    if (this.options?.showLoaderOnContinue) {
      this.isLoading = true;
    }

    if (!this.options?.autoCloseDisabled) {
      this.popupService.popupHide();
    }
  }
}
